import React, { useState } from 'react';
import './contact.css';

const Contact = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const data = new FormData(form);

    try {
      await fetch("https://formsubmit.co/ajax/info@wecanserve.com", {
        method: "POST",
        body: data
      });

      // show success message
      setIsSubmitted(true);

      // reset form fields
      form.reset();

      // bring form back after 3 seconds
      setTimeout(() => {
        setIsSubmitted(false);
      }, 3000);

    } catch (error) {
      console.error("Form submission error:", error);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">

        {/* LEFT */}
        <div className="contact-info">
          <h1>Let’s build the Future.</h1>

          <p className="contact-subtext">
            Have a project in mind? Or just want to say hi? Drop us a message and our team will get back to you.
          </p>

          <div className="contact-details">
            <div className="detail-item">
              <div className="icon-box"><i className="fas fa-phone-alt"></i></div>
              <span>+91 9112135150</span>
            </div>

            <div className="detail-item">
              <div className="icon-box"><i className="fas fa-envelope"></i></div>
              <span>info@wecanserve.com</span>
            </div>

            <div className="detail-item">
              <div className="icon-box"><i className="fas fa-map-marker-alt"></i></div>
              <span>Ghatkopar, Mumbai, MH</span>
            </div>
          </div>

          <div className="social-links">
            <a
    href="https://www.instagram.com/wecanserve.in?utm_source=qr&igsh=cWZsaXJtbHJ3OWQ0"
    target="_blank"
    rel="noreferrer"
  >
    <i className="ri-instagram-line"></i>
  </a>

  <a
    href="https://www.facebook.com/share/1BUxYJMn73/?mibextid=wwXIfr"
    target="_blank"
    rel="noreferrer"
  >
    <i className="ri-facebook-circle-fill"></i>
  </a>
          </div>
        </div>

        {/* RIGHT */}
        <div className="contact-form-card">

          {isSubmitted ? (
            <div className="success-message">
              <h3>Thank you!</h3>
              <p>We’ve received your message. We’ll get back to you shortly.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>

              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_subject" value="New Website Inquiry" />

              <div className="form-body">

                <div className="form-group">
                  <input type="text" name="name" placeholder="Full Name" required />
                </div>

                <div className="form-group">
                  <input type="tel" name="phone" placeholder="Mobile Number (Optional)" />
                </div>

                <div className="form-group">
                  <input type="email" name="email" placeholder="Email Address" required />
                </div>

                <div className="form-group">
                  <select name="service" required>
                    <option value="">Interested Service</option>
                    <option value="Website Development">Website Development</option>
                    <option value="Digital Marketing">Digital Marketing</option>
                    <option value="Performance Marketing">Performance Marketing</option>
                    <option value="Personal Branding"> Personal Branding</option>
                    <option value="SEO Services">SEO Services</option>
                    <option value="Content Creation">Content Creation</option>
                    <option value="PR & Media Coverage">PR & Media Coverage</option>
                    <option value="AI Automation Solutions">AI Automation Solutions</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="form-group textarea-group">
                  <textarea name="message" placeholder="Your Message" required></textarea>
                </div>

              </div>

              <div className="form-footer">
                <button type="submit" className="btn-send">Send Message</button>
                <img src="/services-page/arrow-blue.png" alt="decoration" className="plane-decor" />
              </div>

            </form>
          )}

        </div>

      </div>
    </div>
  );
};

export default Contact;